import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {fromEvent } from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';

@Component({
  selector: 'beaconstac-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  /**
   * Search box placeholder
   *
   * @required
   */
  @Input()
  searchPlaceholder = 'Search';

  /**
   * Search box default text
   *
   * @required
   */
  @Input()
  text = '';

  /**
   * Element id for document
   *
   * @required
   */
  @Input()
  id = '';

  @Input()
  width = '';

  /**
   * Optional change handler
   */
  @Output()
  textChange = new EventEmitter<Event>();

  @ViewChild('input') input: ElementRef;

  ngAfterViewInit() {
    // server-side search
    fromEvent(this.input.nativeElement,'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(300),
        distinctUntilChanged(),
        tap((text) => {
          this.textChange.emit(this.input.nativeElement.value);
        })
      )
      .subscribe();
  }
}
